import { render, staticRenderFns } from "./orderStatisticsDetail.vue?vue&type=template&id=37bca854&scoped=true"
import script from "./orderStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./orderStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./orderStatisticsDetail.vue?vue&type=style&index=0&id=37bca854&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bca854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bca854')) {
      api.createRecord('37bca854', component.options)
    } else {
      api.reload('37bca854', component.options)
    }
    module.hot.accept("./orderStatisticsDetail.vue?vue&type=template&id=37bca854&scoped=true", function () {
      api.rerender('37bca854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/orderStatistics/orderStatisticsDetail.vue"
export default component.exports